<!-- Step: REQUEST FORM -->
<div
  id="step-request-form"
  class="flex min-h-0 flex-1 flex-col"
>
  <form
    id="request-form"
    class="flex flex-1 flex-col pt-6"
    *ngIf="!submitSuccess; else requestSuccess"
    (ngSubmit)="submitForm()"
    #healthSystemRequestForm="ngForm"
  >
    <div class="space-y-6">
      <div id="request-form-header" class="space-y-2">
        <h2 class="fdk-type-heading-2 text-fdk-primary">
          Request your Health System
        </h2>
        <p class="fdk-type-paragraph text-fdk-secondary">
          Sharing your email address and related information helps us prioritize
          your Health System.
        </p>
      </div>

      <div class="space-y-4">
        <fdk-input
          id="request-email"
          [(ngModel)]="formRequestHealthSystem.email"
          name="email"
          #email="ngModel"
          label="Your email address"
          type="email"
          autocomplete="email"
          placeholder="you@example.com"
          required
          email
          [error]="email.invalid && (email.dirty || email.touched)"
          [errorMessage]="
            email.errors?.['required']
              ? 'Email is required.'
              : email.errors?.['email']
                ? 'Email must be valid.'
                : ''
          "
        />

        <fdk-input
          id="request-healthsystem"
          [(ngModel)]="formRequestHealthSystem.name"
          name="name"
          #name="ngModel"
          label="Health system name"
          type="text"
          placeholder="Mayo Clinic, Cleveland Clinic, Kaiser Permanente"
          required
          [minlength]="4"
          [error]="name.invalid && (name.dirty || name.touched)"
          [errorMessage]="
            name.errors?.['required']
              ? 'Health system name is required.'
              : name.errors?.['minlength']
                ? 'Health system name must be at least 4 characters long.'
                : ''
          "
        />

        <fdk-input
          id="request-website"
          [(ngModel)]="formRequestHealthSystem.website"
          name="website"
          #website="ngModel"
          label="Website"
          type="text"
          placeholder="www.mayoclinic.org"
          required
          [minlength]="4"
          [error]="website.invalid && (website.dirty || website.touched)"
          [errorMessage]="
            website.errors?.['required']
              ? 'Website is required.'
              : website.errors?.['minlength']
                ? 'Website must be at least 4 characters long.'
                : ''
          "
        />

        <fdk-input
          id="request-address"
          [(ngModel)]="formRequestHealthSystem.street_address"
          name="street_address"
          label="Street Address"
          type="text"
          placeholder="123 Broadway, New York, NY"
        />
      </div>
    </div>

    <div class="mt-fdk-s">
      <fdk-alert
        *ngIf="errorMsg"
        title="We couldn't submit your request."
        [description]="errorMsg"
        variant="error"
      />
    </div>

    <div class="health-system-request-actions mt-auto pt-6">
      <fdk-button
        id="health-system-request-submit"
        type="submit"
        variant="primary"
        width="full"
        [disabled]="!healthSystemRequestForm.form.valid || loading"
      >
        <span class="flex items-center justify-center gap-2"
          ><fdk-spinner *ngIf="loading" /> Submit</span
        >
      </fdk-button>
    </div>
  </form>
</div>
<!-- End Step: REQUEST FORM -->

<ng-template #requestSuccess>
  <div
    id="request-success-animation"
    class="flex flex-1 flex-col text-center mt-fdk-xxxl"
  >
    <div>
      <fdk-illustration name="success" />
      <h2 class="fdk-type-heading-2 text-fdk-primary mt-fdk-l">
        Request received
      </h2>
      <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
        Thanks for letting us know. We'll notify you when this provider is
        available.
      </p>
    </div>

    <div class="health-system-request-success-actions mt-auto pt-6">
      <fdk-button
        id="health-system-request-done"
        type="button"
        variant="secondary"
        width="full"
        (click)="dismiss()"
      >
        Done
      </fdk-button>
    </div>
  </div>
</ng-template>
